import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccountSettingsLayoutComponent } from './layout/account-settings-layout.component';
import { AccountSettingsComponent } from './general/account-settings.component';
import { AccountInvoiceComponent } from './invoice/account-invoice.component';
import { AccountSubscriptionComponent } from './subscription/account-subscription.component';
import { AccountSettingsRouting } from './account-settings.routing';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { ModalsModule } from '../../modals/modals.module';
import { AccountSettingsSideMenuComponent } from './side-menu/account-settings-side-menu.component';
import { AccountTeamComponent } from './team/account-team.component';
import { AccountAuditComponent } from './audit/account-audit.component';
import { AuditAdvancedFilterComponent } from './audit/advanced-filter/audit-advanced-filter.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { QuillModule } from 'ngx-quill';

@NgModule({
  declarations: [
    AccountSettingsLayoutComponent,
    AccountSettingsComponent,
    AccountInvoiceComponent,
    AccountSubscriptionComponent,
    AccountSettingsSideMenuComponent,
    AccountTeamComponent,
    AccountAuditComponent,
    AuditAdvancedFilterComponent,
  ],
  exports: [
    AccountSettingsLayoutComponent,
    AccountSettingsComponent,
    AccountInvoiceComponent,
    AccountSubscriptionComponent,
    AccountSettingsSideMenuComponent,
    AccountTeamComponent,
    AccountAuditComponent,
    AuditAdvancedFilterComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ModalsModule,
    SharedModule,
    QuillModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    CollapseModule.forRoot(),
    TypeaheadModule,
    AccountSettingsRouting,
    PaginationModule.forRoot(),
    TooltipModule.forRoot(),
  ],
})
export class AccountSettingsModule {
  constructor() {
    console.log('>>> Bootstrap AccountSettingsModule');
  }
}
